const dataWasteCategory = [
  {
    category: "Plastik",
    info: " Mencakup produk polimerisasi sintetik atau semi-sintetik.",
  },
  {
    category: "Kertas",
    info: "bahan tipis yang dihasilkan dari kompresi serat yang berasal dari pulp.",
  },
  {
    category: "Botol",
    info: "tempat penyimpanan dengan bagian leher yang lebih sempit daripada badan.",
  },
  {
    category: "Karet",
    info: " polimer hidrokarbon yang terkandung pada lateks beberapa jenis tumbuhan.",
  },
  {
    category: "Kaca",
    info: "berasal dari bahan yang bersifat cair namun memiliki kepadatan tinggi, dan struktur amorf. ",
  },
  {
    category: "Kayu",
    info: "bagian batang atau cabang serta ranting tumbuhan yang mengeras karena mengalami lignifikasi",
  },
];

export default dataWasteCategory;
